import { FC, useCallback } from 'react';

import { PATHS } from '@/constants/routes';
import shallow from 'zustand/shallow';
import { useClearBooking } from '@/logic/hooks/use-clear-booking';
import { useDialog } from '@/logic/state';
import { useRouter } from 'next/router';
import { ConfirmDialog } from '@/components/shared/confirm-dialog';

export const CancelSeatsSelectionConfirmDialog: FC = () => {
  const router = useRouter();

  const [dialog, setDialog] = useDialog(s => [s.dialog, s.setDialog], shallow);
  const { clearBooking } = useClearBooking();

  const handleCloseClick = useCallback(() => {
    setDialog({});
  }, [setDialog]);

  const handleOkayClick = useCallback(() => {
    if (dialog?.cancelSeatsSelectionConfirmDialogPayload?.redirect) {
      dialog?.cancelSeatsSelectionConfirmDialogPayload?.removeOnRouteChangeStartListener();
      setDialog({});
      router.push(dialog?.cancelSeatsSelectionConfirmDialogPayload?.nextPath);
    } else {
      clearBooking();
      setDialog(prevState => ({
        wrapper: false,
        rulesOfEntryDialogPayload: prevState?.rulesOfEntryDialogPayload,
      }));

      setTimeout(() => {
        setDialog(prevState => ({
          wrapper: true,
          isRulesOfEntryDialog: true,
          rulesOfEntryDialogPayload: prevState?.rulesOfEntryDialogPayload,
        }));
      }, 500);
    }
  }, [clearBooking, dialog?.cancelSeatsSelectionConfirmDialogPayload, router, setDialog]);

  return (
    <ConfirmDialog
      buttonId='change-page-confirm-dialog'
      img='/icons/booking/cancel-seats-selection-icon.svg'
      widthImage='149px'
      heightImage='103px'
      altImage='alt.cancel_selection_seats_icon'
      title={
        router.pathname === PATHS.MOVIES_SLUG_BOOKING
          ? 'booking.cancel_seats_selection'
          : 'booking.cancel_checkout'
      }
      description={
        router.pathname === PATHS.MOVIES_SLUG_BOOKING
          ? 'booking.cancel_seats_selection_confirm_dialog.seats_page.description'
          : 'booking.cancel_seats_selection_confirm_dialog.checkout_page.description'
      }
      handleOkayClick={handleOkayClick}
      handleCloseClick={handleCloseClick}
    />
  );
};
